import { render, staticRenderFns } from "./BindInstanceGroup.vue?vue&type=template&id=27701084&"
import script from "./BindInstanceGroup.vue?vue&type=script&lang=js&"
export * from "./BindInstanceGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports